import type { FC, ReactNode, Ref } from 'react';

import cn from 'classnames';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/ui/Tooltip';

interface ToolbarButtonProps {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  active?: boolean;
  disabled?: boolean;
  buttonRef?: Ref<HTMLButtonElement>;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

export const ToolbarButton: FC<ToolbarButtonProps> = ({
  icon,
  label,
  onClick,
  active,
  disabled,
  buttonRef,
  buttonProps,
}) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          ref={buttonRef}
          type="button"
          disabled={disabled}
          onClick={onClick}
          aria-label={label}
          aria-pressed={active}
          className={cn('flex items-center h-8 px-2 py-1 rounded-full transition-colors', {
            'opacity-50 cursor-not-allowed': disabled,
            'hover:bg-black/5': !disabled && !active,
            'bg-black/10': !disabled && active,
          })}
          {...buttonProps}
        >
          {icon}
        </button>
      </TooltipTrigger>
      <TooltipContent sideOffset={4} style={{ zIndex: 100 }}>
        <div className="p-1 rounded-md border text-xs font-medium bg-black text-white leading-none">{label}</div>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
